import { Stack, Typography } from '@mui/material';
import Grid2 from '@mui/material/Grid2';

import { colors } from 'src/global/styles/colors';

import { ProjectStatisticsTable } from './ProjectStatisticsTable';
import { SalesDistributionChart } from './SalesDistributionChart';
import { TopProjectsChart } from './TopProjectsChart';

export function ProjectSalesSection() {
  return (
    <Stack spacing={3}>
      <Typography
        variant='h5'
        sx={{
          fontFamily: 'Gotham',
          fontWeight: 700,
          fontSize: '24px',
          color: colors.white,
          lineHeight: 1.17,
        }}>
        Project Sales Details
      </Typography>

      {/* Project Statistics Table */}
      <ProjectStatisticsTable />

      {/* Charts Row */}
      <Grid2 container spacing={3}>
        <Grid2 size={{ xs: 12, lg: 6 }}>
          <SalesDistributionChart />
        </Grid2>
        <Grid2 size={{ xs: 12, lg: 6 }}>
          <TopProjectsChart />
        </Grid2>
      </Grid2>
    </Stack>
  );
}
